import React, { useMemo, memo } from "react";
import { useFormikContext } from "formik";
import { Typography } from "@mui/material";

import RpCurrencyField from "@/components/muiCustom/textField/RpCurrencyField";

type RRDLocationTotalCostProps = {
  locationId: string | number;
  distributionCost?: number;
  storeCopyCost?: number;
};

const CurrencyField = RpCurrencyField as React.ElementType;

function RRDLocationTotalCost({
  locationId,
  distributionCost,
  storeCopyCost,
}: RRDLocationTotalCostProps) {
  const { setFieldValue } = useFormikContext();

  const totalCost = useMemo(() => {
    return (distributionCost || 0) + (storeCopyCost || 0);
  }, [distributionCost, storeCopyCost]);

  React.useEffect(() => {
    setFieldValue(`${locationId}.total_cost`, totalCost);
  }, [locationId, totalCost, setFieldValue]);

  return (
    <>
      <Typography
        variant="body2"
        gutterBottom
        fontWeight={600}
        className="mb-2"
        sx={{ display: "block", lineHeight: 1.35 }}
      >
        Total Cost
      </Typography>
      <CurrencyField
        fullWidth
        size="small"
        value={totalCost}
        readOnly
        disabled={distributionCost || storeCopyCost ? false : true}
        placeholder="0.00"
        fixedDecimalScale={true}
        sx={{
          "& .MuiOutlinedInput-root": {
            opacity: 0.6,
            pointerEvents: "none",
          },
        }}
      />
    </>
  );
}

export default memo(RRDLocationTotalCost);
